import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { StyleSheet, View } from "react-native";
import "../../../../App.scss";
import Page1 from "./page1";
import Page2 from "./page2";
import Page3 from "./page3";
import Page4 from "./page4";
import Page5 from "./page5";
import ModuleTop from "../../../../Components/Layout/Default/module-top";
export default function Index(props) {
  const [display, setDisplay] = useState(false);
  const [pageSecond, setPageSecond] = useState(true);
  const [pageThird, setPageThird] = useState(true);
  const [pageFourth, setPageFourth] = useState(true);
  const [pageFifth, setPageFifth] = useState(true);
  const [skippedQuestion, setSkippedQuestion] = useState(false);
  useLayoutEffect(() => {
    const delay = setTimeout(() => {
      setDisplay(true);
    }, 800); // starts after the top bar has finished animating

    return () => clearTimeout(delay);
  }, []);

  const Refresh = () => {
    setPageSecond(false);
  };
  const pageThree = () => {
    setPageThird(false);
  };
  const pageFour = () => {
    setPageFourth(false);
  };
  const pageFive = () => {
    setPageFifth(false);
  };
  return (
    <View style={[styles.container, { height: "100vh" }]}>
      <ModuleTop module="exp" active={true} />
      {display &&
        (pageSecond ? (
          <Page1 Refresh={Refresh} {...props} />
        ) : pageThird ? (
          <Page2
            Refresh={pageThree}
            setSkippedQuestion={setSkippedQuestion}
            skippedQuestion={skippedQuestion}
            {...props}
          />
        ) : pageFourth ? (
          <Page3
            Refresh={pageFour}
            {...props}
            setSkippedQuestion={setSkippedQuestion}
            skippedQuestion={skippedQuestion}
          />
        ) : pageFifth ? (
          <Page4
            Refresh={pageFive}
            {...props}
            setSkippedQuestion={setSkippedQuestion}
            skippedQuestion={skippedQuestion}
          />
        ) : (
          <Page5
            {...props}
            setSkippedQuestion={setSkippedQuestion}
            skippedQuestion={skippedQuestion}
          />
        ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100vw",
    //flex: 1,
    // backgroundColor: "#eeeeee",
    overflow: "hidden",
  },
});
